import { useState, useEffect } from 'react';
import { Checkbox } from '../../../checkbox'

import { Container } from './style';

export function State({ state, statesListChecked, setStatesListChecked, setListStatesToSearch, listStatesToSearch }) {
  const [selectedState, setSelectedState] = useState(0) 
    

  function handleSetStateChecked() {
    if(selectedState === 0){
      setStatesListChecked([...statesListChecked, state.idState])
      setListStatesToSearch([...listStatesToSearch, state.idState])
    }
    else{
        setStatesListChecked(statesListChecked.filter(stt =>{
          return stt !== state.idState
        }))
        setListStatesToSearch(listStatesToSearch.filter(stt =>{
          return stt !== state.idState
        }))
    }
  }


  useEffect(() =>{
    if(statesListChecked.some(stt => ( stt === state.idState )))
      setSelectedState(1)
    else{
      setSelectedState(0)
    }
  }, [statesListChecked, state])



  return(
      <Container>

          <strong>&#8226;</strong>
          <Checkbox 
            selected={selectedState} 
            handleChangeStatus={handleSetStateChecked}
            size={'1.4rem'}
          />
          <p>{state.state}</p>

      </Container>
  )
}
